import { useSelectMetricCardNavigateMetaData } from 'Deer/slice/MetricCardNavigateMetaData.slice';
import { matchPath, useLocation } from 'react-router-dom';

export const isOnTargetPage = ({ currentPath, targetPath }) => {
  const match = matchPath(currentPath, {
    path: targetPath,
    exact: true,
  });
  return !!match;
};

export const useRouteMatchMetricCardFilter = ({ gridStatePersistenceKey }) => {
  const metricCardNavigateMetaData = useSelectMetricCardNavigateMetaData();
  const location = useLocation();

  if (!metricCardNavigateMetaData) {
    return {};
  }

  const {
    targetPage,
    filters,
    gridStatePersistenceKey: targetGridStatePersistenceKey,
    filterKeysToClear,
  } = metricCardNavigateMetaData;
  // null targetGridStatePersistenceKey means that the navigation is within same page only.
  if (targetGridStatePersistenceKey !== null && gridStatePersistenceKey !== targetGridStatePersistenceKey) {
    return {};
  }
  if (!targetPage || isOnTargetPage({ currentPath: location.pathname, targetPath: targetPage })) {
    if (filterKeysToClear) {
      return { applicableFilterKeysToClear: filterKeysToClear };
    }
    return { applicableFiltersToSet: filters };
  }
  return {};
};
